<template>
  <div class="realname">
    <div style="width:100%">
      <h3>举报人信息 (注意: 标有 <span class="must">*</span> 的必须填写)</h3>
      <el-form ref="formdata" :model="formdata" label-width="80px" :rules="rulesFrom">
        <div class="row">
          <el-form-item label="举报人类型" prop="informantType" style="display:flex;align-items:center">
            <el-radio-group v-model="formdata.informantType" style="width: 200px;margin-left:0"
                            @change="informantTypeChange">
              <el-radio v-model="formdata.informantType" :label="'1'">个人</el-radio>
              <el-radio v-model="formdata.informantType" :label="'2'">单位</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="informant1" v-if="formdata.informantType == '1' || formdata.informantType == undefined">
          <div class="row">
            <el-form-item label="举报人姓名" prop="informantName">
              <el-input v-model="formdata.informantName" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="单位名称" prop="informantUnit">
              <el-input v-model="formdata.informantUnit" maxlength="32"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="证件类型" prop="informantDocumentType">
              <el-select
                  v-model="formdata.informantDocumentType"
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号" prop="informantIdNumber">
              <el-input v-model="formdata.informantIdNumber" maxlength="18" show-word-limit></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="手机号" prop="informantPhone">
              <el-input v-model="formdata.informantPhone" maxlength="11" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="checkCode">
              <template>
                <el-input v-model="formdata.checkCode"></el-input>
                <el-button
                    type="primary"
                    style="margin-left: 10px;margin-top: 4px;margin-right: 100px"
                    @click="queryphone"
                    v-if="iscode"
                >获取验证码
                </el-button
                >
                <el-button
                    key="index"
                    v-else
                    type="primary"
                    style="margin-left: 10px"
                    disabled
                >{{ timer }}秒后重新获取
                </el-button
                >
              </template>
            </el-form-item>
          </div>
          <div class="row" style="height:42px">
            <el-form-item label="有效证件附件" class="required" style="width: 250px; height:44px"
                          prop="certificateAttachmentIds">
              <el-upload
                  class="upload"
                  :action="effectiveUrl"
                  :on-change="handleExcel"
                  accept="image/jpeg, image/png, bmp, image/jpeg, image/tiff"
                  :auto-upload="true"
                  show-file-list
                  :file-list="certificateFileList"
                  :before-remove="beforeremove"
                  :headers="{'OTP': otp}"
                  :on-success="effectivesuccess"
              >
                <el-button icon="el-icon-folder-add" type="primary"
                >上传文件
                </el-button
                >
              </el-upload>
            </el-form-item>
          </div>
          <div class="row" v-if="twoisshow">
            <!-- <el-form-item label="" style="margin-left: -70px; width: 84%"> -->
            <span style="font-size: 0.9em;">
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意:
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back"
                         @click="twoisshow = false">
                </p>
              严禁冒用他人姓名和身份举报！
              冒名举报将承担法律责任，温馨提示：
              请上传举报人有效身份证件图片信息，每个文件不大于2M。附件仅限于文件名后缀为.jpg、.png、.bmp、.peg、.tiff的文件，禁止exe、bat等格式文件上传；手机号和邮箱应为本人常用联系方式。</span>
            <!-- </el-form-item> -->
          </div>
        </div>
        <div class="informant2" v-if="formdata.informantType == '2'">
          <div class="row">
            <el-form-item label="单位名称" prop="informantUnitName">
              <el-input v-model="formdata.informantUnitName" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="informantUnitCode">
              <el-input v-model="formdata.informantUnitCode" maxlength="18"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="联系人" prop="contactPersonUnit">
              <el-input v-model="formdata.contactPersonUnit" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="联系人手机号" prop="contactPhoneUnit">
              <el-input v-model="formdata.contactPhoneUnit" maxlength="11"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="验证码" prop="checkCode">
              <template>
                <el-input v-model="formdata.checkCode"></el-input>
                <el-button
                    type="primary"
                    style="margin-left: 10px;margin-top: 4px;margin-right: 100px"
                    @click="queryphone"
                    v-if="iscode"
                >获取验证码
                </el-button>
                <el-button
                    key="index"
                    v-else
                    type="primary"
                    style="margin-left: 10px"
                    disabled
                >{{ timer }}秒后重新获取
                </el-button>
              </template>
            </el-form-item>
          </div>
          <div class="row" style="height:42px">
            <el-form-item label="营业执照扫描件" class="required" style="width: 250px; height:44px"
                          prop="businessLicenseIds">
              <el-upload
                  class="upload"
                  :action="effectiveUrl"
                  :on-change="handleExcel"
                  accept="application/pdf"
                  :auto-upload="true"
                  show-file-list
                  :file-list="businessLicenseFileList"
                  :before-remove="businessLicenseRemove"
                  :headers="{'OTP': otp}"
                  :on-success="businessLicenseSuccess"
              >
                <el-button icon="el-icon-folder-add" type="primary"
                >上传文件
                </el-button
                >
              </el-upload>
            </el-form-item>
          </div>
          <div class="row" style="height:42px">
            <el-form-item label="举报材料" class="required" style="width: 250px; height:44px"
                          prop="reportAttachmentIds">
              <el-upload
                  class="upload"
                  :action="effectiveUrl"
                  :on-change="handleExcel"
                  accept="application/pdf"
                  :auto-upload="true"
                  show-file-list
                  :file-list="reportAttachmentFileList"
                  :before-remove="reportAttachmentRemove"
                  :headers="{'OTP': otp}"
                  :on-success="reportAttachmentSuccess"
              >
                <el-button icon="el-icon-folder-add" type="primary"
                >上传文件
                </el-button
                >
              </el-upload>
            </el-form-item>
          </div>
          <div class="row" v-if="twoisshow">
            <span style="font-size: 0.9em;">
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意:
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back"
                         @click="twoisshow = false">
                </p>
              严禁冒用他人单位信息举报！
              冒名举报将承担法律责任，温馨提示：
              请上传举报单位有效营业执照扫描件和举报材料（加盖单位公章），每个文件不大于5M。附件仅限于文件名后缀为.pdf的文件，禁止exe、bat等格式文件上传；联系人手机号应为单位联系人有效联系方式。</span>
            <!-- </el-form-item> -->
          </div>
        </div>

        <h3>举报信息 (注意: 标有 <span class="must">*</span> 的必须填写)</h3>
        <div class="row">
          <el-form-item label="问题类型" prop="questionType" >
            <el-select v-model="formdata.questionType" placeholder="请选择问题类型" style="width: 260px; margin-left: 0;" @change="questionTypeChange">
              <el-option key="" label="--请选择问题类型--" value=""></el-option>
              <el-option v-for="item in questionTypeOptions" :key="item.typeCode" :label="item.typeValue" :value="item.typeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="违规主体" prop="unreliableType">
            <el-select v-model="formdata.unreliableType" placeholder="请选择违规主体" style="width: 260px; margin-left: 0;" @change="unreliableTypeChange">
              <el-option key="" label="--请选择违规主体--" value=""></el-option>
              <el-option v-for="item in unreliableTypeOptions" :key="item.typeCode" :label="item.typeValue" :value="item.typeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="违规行为" prop="unreliableActType" style="width: 100%; margin-bottom: 2px">
            <el-select v-model="formdata.unreliableActType" placeholder="请选择违规行为" style="width: 100%; margin-left: 0;" multiple collapse-tags>
              <el-option v-for="item in unreliableActTypeOptions" :key="item.typeCode" :label="item.typeValue" :value="item.typeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row" style="margin-bottom: 20px">
          <!-- 单独显示选中项的区域 -->
          <div class="selected-tags" style="width: 100%;" v-if="formdata.unreliableActType && formdata.unreliableActType.length > 0">
          <!--  <div class="tag-label">已选择违规行为：</div>-->
            <el-tag v-for="(item, index) in getSelectedLabels(formdata.unreliableActType)"
                    :key="index" closable  @close="removeTag(index)" style="margin: 2px 2px 2px 80px;">
              {{ item }}
            </el-tag>
          </div>
        </div>
        <div class="row" v-show="false">
          <el-form-item label="举报对象" prop="reportSubject" style="display:flex;align-items:center">
            <el-radio-group v-model="formdata.reportSubject"
                            style="width: 200px;margin-left:0" @change="subjectChangeForm">
              <el-radio v-model="formdata.reportSubject" :label="'1'">个人</el-radio>
              <el-radio v-model="formdata.reportSubject" :label="'2'">单位</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="individual" v-if="formdata.reportSubject == '1' || formdata.reportSubject == undefined">
          <div class="row">
            <el-form-item label="被举报人姓名" prop="unreliableName">
              <el-input v-model="formdata.unreliableName" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="所在单位/机构名称" prop="unitName">
              <el-input v-model="formdata.unitName" maxlength="32"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="证件号" prop="idNo">
              <el-input v-model="formdata.idNo" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="unreliablePhoneNumber">
              <el-input v-model="formdata.unreliablePhoneNumber" maxlength="11"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="individual" v-if="formdata.reportSubject == 2">
          <div class="row">
            <el-form-item label="单位/机构名称" prop="unreliableUnitName">
              <el-input v-model="formdata.unreliableUnitName" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="uscc">
              <el-input v-model="formdata.uscc" maxlength="18"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <el-form-item label="举报内容" style="width: 100%" prop="reportItem">
            <el-input
                type="textarea"
                v-model="formdata.reportItem"
                style="width: 100%"
                placeholder="请填写举报内容，不多于5000字"
                maxlength="5000"
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="个人诉求" style="width: 100%" prop="informantAppeal">
            <el-input type="textarea" v-model="formdata.informantAppeal" maxlength="2000"
                      placeholder="请填写个人诉求，不多于2000字"></el-input>
          </el-form-item>
        </div>
        <div class="row" style="height:42px">
          <el-form-item label="佐证材料" style="width: 250px" prop="reportFileIds">
            <el-upload
                class="upload"
                :action="effectiveUrl"
                :multiple="true"
                show-file-list
                :file-list="reportFileList"
                :on-change="handleExcel"
                accept='image/jpeg, image/png, bmp, image/jpeg, image/tiff,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,  application/vnd.ms-excel, application/pdf'
                :auto-upload="true"
                :before-remove="evidenbeforeremove"
                :before-upload="beforeUploadFile"
                :headers="{'OTP': otp}"
                :on-success="evidencesuccess"
            >
              <el-button icon="el-icon-folder-add" type="primary"
              >上传文件
              </el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <p style="color: red; font-size: 0.9rem; margin-left: 80px">提示：如无佐证材料，请上传签字的原因或情况说明。</p>
        <div class="row" v-if="isshow">
            <span style="font-size: 0.9em;">
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意:
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back" @click="isshow = false">
                </p>每个文件不大于20M。支持Word、PowerPoint、Excel可编辑文档、PDF、图片，附件仅限于文件名后缀为.jpg、 .png、 .bmp、 .jpeg、 .tiff、 .doc、 .docx、 .ppt、 .pptx、 .xls、 .xlsx、 .pdf的文件，禁止exe、 bat等格式文件上传！超过20M的附件，请通过固态载体(U盘或硬盘) 邮寄给我们。</span>
        </div>

        <div class="row jc-c">
          <el-button @click="back">取消</el-button>
          <el-button type="info" :loading="loading1" @click="staging">暂存</el-button>
          <el-button type="primary" :loading="loading" @click="submit">提交</el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
import personService from "@/api/report/report.js";
import baseURL from "@/utils/baseUrl1";

export default {
  data () {
    const checkphone = (rule, value, callback) => {
      if (!(/^1[345789]\d{9}$/.test(value))) {  //手机号正则校验
        if (!value) { //若手机号为空///
          callback()
        } else { //手机号非空的报错信息
          callback("手机号码格式错误")
        }
      } else { //手机号正确则无错误信息
        this.s_telephone1 = "";
        callback()
      }
    }
    //身份证校验
    const isCnNewID = (rule, value, callback) => {
      var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
      var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
      if (/^\d{17}\d|x$/i.test(value)) {
        var sum = 0, idx;
        for (var i = 0; i < value.length - 1; i++) {
          // 对前17位数字与权值乘积求和
          sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
        }
        // 计算模（固定算法）
        idx = sum % 11;
        // 检验第18为是否与校验码相等
        if (arrValid[idx] == value.substr(17, 1).toUpperCase()) {
          callback()
        } else {
          callback("身份证格式有误")
        }
      } else {
        callback("身份证格式有误")
      }
    }
    return {
      fileList: [],
      reportFileIds: [],
      reportFileList: [],
      certificateFileList: [],
      businessLicenseFileList: [],
      reportAttachmentFileList: [],
      isshow: true,
      twoisshow: true,
      otp: '',
      effectiveUrl: baseURL.person + "/file-deal/report/file-import",
      //   上传格式
      allowHook: {
        video: ["mp4", "ogv", "ogg", "webm"],
        audio: ["wav", "mp3", "ogg", "acc", "webm", "amr"],
        file: ["doc", "docx", "xlsx", "xls", "pdf"],
        excel: ["xlsx", "xls"],
        img: ["jpg", "jpeg", "png", "gif"],
      },
      loading: false,
      loading1: false,
      formdata: {
        informantType: '1',
        certificateAttachment: "", //举报人证件附件
        certificateAttachmentIds: [], //举报人证件附件ID
        businessLicenseIds: [], //营业执照附件ID
        reportAttachmentIds: [],  //举报材料盖章页ID
        reportType: 1, //举报类型 1-实名举报 2-匿名举报
        reportFileIds: [], //佐证材料ID
        informantPhone: '',//举报人手机号
        reportSubject: "",
        questionType: '',
        unreliableType: '',
        unreliableActType: []
      },
      updateFormdata: {
        informantType: '1',
        certificateAttachment: "", //举报人证件附件
        certificateAttachmentIds: [], //举报人证件附件ID
        businessLicenseIds: [], //营业执照附件ID
        reportAttachmentIds: [],  //举报材料盖章页ID
        reportType: 1, //举报类型 1-实名举报 2-匿名举报
        reportFileIds: [], //佐证材料ID
        reportSubject: "",
        questionType: '',
        unreliableType: '',
        unreliableActType: []
      },
      options: [
        {
          value: "1",
          label: "二代身份证",
        },
      ],
      // 问题类型
      questionTypeOptions: [],
      // 主体类型
      unreliableTypeOptions: [],
      // 失信行为
      unreliableActTypeOptions: [],
      iscode: true,
      timer: 60, //验证码倒计时
      disabled: true,
      //非空验证
      rulesFrom: {
        informantType: [{required: true, message: "请选择举报人类型", trigger: "change"}],
        informantName: [{required: true, message: "请输入举报人姓名", trigger: "blur"},],
        informantUnit: [{required: true, message: "请输入单位名称", trigger: "blur"},],
        informantPhone: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          validator: checkphone, trigger: "blur"
        },],
        checkCode: [{required: true, message: "请输入验证码", trigger: "blur"},],
        informantDocumentType: [{required: true, message: "请选择证件类型", trigger: "blur"},],
        informantIdNumber: [{required: true, message: "请输入证件号", trigger: "blur"},
          {
            validator: isCnNewID, trigger: "blur"
          }],
        informantUnitName: [{required: true, message: "请输入单位名称", trigger: "blur"},],
        informantUnitCode: [{required: true, message: "请输入单位统一社会信用代码", trigger: "blur"},
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: '请输入合法统一社会信用代码',
            trigger: 'blur'
          }],
        contactPersonUnit: [{required: true, message: "请输入单位联系人", trigger: "blur"},],
        contactPhoneUnit: [{required: true, message: "请输入联系人手机号", trigger: "blur"}, {
          validator: checkphone, trigger: "blur"
        },],
        reportSubject: [{required: true, message: "请选择举报对象", trigger: "blur"},],
        questionType: [{required: true, message: "请选择问题类型", trigger: "blur"},],
        unreliableName: [{required: true, message: "请输入姓名", trigger: "blur"},],
        unitName: [{required: true, message: "请输入单位名称", trigger: "blur"},],
        unreliableType: [{required: true, message: "请选择违规主体", trigger: "blur"},],
        unreliableActType: [{required: true, message: "请选择违规行为", trigger: "blur"},],
        unreliableUnitName: [{required: true, message: "请输入单位名称", trigger: "blur"},],
        uscc: [{required: true, message: "请输入统一社会信用代码", trigger: "blur"},
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: '请输入合法统一社会信用代码',
            trigger: 'blur'
          }],
        reportItem: [
          {required: true, message: "请输入举报内容", trigger: "blur"},
          // {validator: this.validateContent}
        ],
        informantAppeal: [{required: true, message: "请输入个人诉求", trigger: "blur"},],
        reportFileIds: [{ required: true, message: '请上传佐证材料', trigger: 'blur' }],
        certificateAttachmentIds: [{required: true, message: '请上传证件附件', trigger: 'blur'}],
        businessLicenseIds: [{required: true, message: '请上传营业执照扫描件', trigger: 'blur'}],
        reportAttachmentIds: [{required: true, message: '请上传举报材料', trigger: 'blur'}]
      },
    };
  },
  created () {
    this.formdata.informantDocumentType = '1';
    if (this.$route.query.updateFormdata !== 'undefined' && this.$route.query.updateFormdata != null && this.$route.query.updateFormdata !== '') {
      this.formdata = this.$route.query.updateFormdata;
      this.formdata.reportFileIds = [];
      this.formdata.certificateAttachmentIds = [];
      this.formdata.businessLicenseIds = [];
      this.formdata.reportAttachmentIds = [];
      this.reportFileList = [];
      this.certificateFileList = [];
      this.businessLicenseFileList = [];
      this.reportAttachmentFileList = [];
      this.formdata.unreliableActType = this.formdata.unreliableActType.split(",")
      if (this.formdata.questionType) {
        this.getType(this.formdata.questionType, 2)
      }
      if(this.formdata.unreliableType){
        this.getType(this.formdata.unreliableType, 3)
      }
      // 前后端字段不一致
      this.pushFile(this.formdata.reportFiles, this.formdata.reportFileIds, this.reportFileList)
      this.pushFile(this.formdata.certificateAttachmentFiles, this.formdata.certificateAttachmentIds, this.certificateFileList)
      this.pushFile(this.formdata.businessLicenseFiles, this.formdata.businessLicenseIds, this.businessLicenseFileList)
      this.pushFile(this.formdata.reportAttachmentFiles, this.formdata.reportAttachmentIds, this.reportAttachmentFileList)
      this.formdata.reportSubject = 1
      // console.log(this.formdata);
    }
  },
  methods: {
    getSelectedLabels(selectedValues) {
      return selectedValues.map(value => {
        const option = this.unreliableActTypeOptions.find(item => item.typeCode === value);
        return option ? option.typeValue : value;
      });
    },
    removeTag(index) {
      this.formdata.unreliableActType.splice(index, 1);
    },
    pushFile (files, fileIds, fileList) {
      if (files) {
        files.forEach(element => {
          let obj = {
            name: element.fileName,
            id: element.id
          }
          fileList.push(obj);
          fileIds.push(element.id);
        })
      }
    },
    subjectChangeForm () {
      this.$refs['formdata'].clearValidate()
      // if (this.formdata.reportSubject === "1") {
      //   this.$refs['formdata'].clearValidate(['unreliableName'])
      //   this.$refs['formdata'].clearValidate(['unitName'])
      // }
      // if (this.formdata.reportSubject === "2") {
      //   this.$refs['formdata'].clearValidate(['unreliableUnitName'])
      //   this.$refs['formdata'].clearValidate(['uscc'])
      // }
    },
    informantTypeChange () {
      this.$refs['formdata'].clearValidate()
    },
    // 身份证验证
    async validSjh (rule, value, callback) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      let reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("你输入的身份证长度或格式错误"));
      } else {
        //身份证城市
        var aCity = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外"
        };
        if (!aCity[parseInt(value.substr(0, 2))]) {
          callback(new Error("你的身份证地区非法"));
        }
        // 出生日期验证
        var sBirthday = (
                value.substr(6, 4) + "-" +
                Number(value.substr(10, 2)) + "-" +
                Number(value.substr(12, 2))
            ).replace(/-/g, "/"),
            d = new Date(sBirthday);
        if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) {
          callback(new Error("身份证上的出生日期非法"));
        }

        // 身份证号码校验
        var sum = 0,
            weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
            codes = "10X98765432";
        for (var i = 0; i < value.length - 1; i++) {
          sum += value[i] * weights[i];
        }
        var last = codes[sum % 11]; //计算出来的最后一位身份证号码
        if (value[value.length - 1] != last) {
          callback(new Error("你输入的身份证号非法"));
        } else {
          await this.go(value, value.length);
        }
        callback();
      }
    },
    // 返回上一级
    back () {
      this.$router.back();
    },
    getType (parentCode, level) {
      if (!parentCode && parentCode !== '0') {
        return
      }
      personService.getType(parentCode).then((res) => {
        if (level === 1) {
          this.questionTypeOptions = res.data;
        }
        if (level === 2) {
          this.unreliableTypeOptions = res.data;
        }
        if (level === 3) {
          this.unreliableActTypeOptions = res.data;
        }
      }).catch(error => {
        this.$message({message: error, type: 'warning'});
      })
    },
    // 问题类型变化
    questionTypeChange () {
      this.formdata.unreliableType =  ''
      this.formdata.unreliableActType =  []
      this.getType(this.formdata.questionType,2)
    },
    // 违规主体变化
    unreliableTypeChange () {
      this.formdata.unreliableActType =  []
      this.formdata.reportSubject = this.unreliableTypeOptions.find(item => item.typeCode === this.formdata.unreliableType).mainType
      this.getType(this.formdata.unreliableType,3)
    },
    // 暂存信息
    staging () {
      //1.在低版本中validateField的第一个参数只能接收String类型，这里以String为例
      //将需要进行表单校验的参数放在一个数组中
      let valiSome = []
      if (this.formdata.informantType == '1') {
        valiSome = ['informantName', 'informantPhone', 'reportSubject']
      } else {
        valiSome = ['informantUnitName', 'contactPhoneUnit', 'reportSubject']
      }
      //设置布尔值
      var flag = true
      //使用validateField方法来进行多个参数验证
      valiSome.forEach((item, key) => {
        this.$refs.formdata.validateField(item, valid => {
          if (valid.length) {
            return flag = false
          }
        })
      })
      if (!flag) {
        this.$message({
          message: '暂存提交请必填“举报人姓名/单位名称，手机号”跟“举报对象”',
          type: 'warning'
        });
        return
      }
      if (this.formdata.id !== 'undefined' && this.formdata.id != null && this.formdata.id !== '') {
        this.formdata.isSubmit = 0
        delete this.formdata.certificateFileId
        delete this.formdata.certificateAttachmentFiles
        delete this.formdata.reportFiles
        if (flag) {
          this.loading1 = true
          // 处理多选框
          let params = JSON.parse(JSON.stringify(this.formdata))
          params.unreliableActType = this.formdata.unreliableActType.join(',')
          personService.updatereport(params).then((res) => {
            this.$msgbox('暂存成功 可到反馈结果页面查询并修改数据', '提示', {
              confirmButtonText: '确定',
            })
            this.loading1 = false
            this.formdata.workOrderNo = res.data
          }).catch(res => {
            this.loading1 = false
            this.$message({
              message: res.response.data.message,
              type: 'warning'
            });
          })
        }
      } else {
        this.formdata.isSubmit = 0
        if (flag) {
          this.loading1 = true
          // 处理多选框
          let params = JSON.parse(JSON.stringify(this.formdata))
          params.unreliableActType = this.formdata.unreliableActType.join(',')
          personService.reportsub(params, this.otp).then((res) => {
            this.$msgbox('暂存成功 可到反馈结果页面查询并修改数据', '提示', {
              confirmButtonText: '确定',
            })
            this.loading1 = false
            this.formdata.workOrderNo = res.data
            this.getOtp()
          }).catch(err => {
            console.log(err);
            this.loading1 = false
            this.$message({
              message: err.response.data.message,
              type: "warning",
            });
            this.getOtp()
          })
        }
      }
    },
    // 提交信息
    submit () {
      if (this.formdata.id !== 'undefined' && this.formdata.id != null && this.formdata.id !== '') {
        delete this.formdata.certificateFileId
        delete this.formdata.certificateAttachmentFiles
        delete this.formdata.reportFiles
        this.$refs.formdata.validate((valid, errors) => {
          // 点击确定新增校验哪些值没传
          if (valid) {
            this.formdata.isSubmit = 1
            this.loading = true
            // 处理多选框
            let params = JSON.parse(JSON.stringify(this.formdata))
            params.unreliableActType = this.formdata.unreliableActType.join(',')
            personService.updatereport(params).then((res) => {
              if (res.code != '200') {
                this.$message({
                  message: res.message,
                  type: 'warning'
                });
                this.loading = false
                return
              }
              this.$message({
                message: '提交成功 可到反馈结果页面查看',
                type: 'success'
              });
              this.formdata = {
                informantType: '1',
                informantDocumentType: "1",
                certificateAttachment: "", //举报人证件附件
                certificateAttachmentIds: [], //举报人证件附件ID
                businessLicenseIds: [], //营业执照附件ID
                reportAttachmentIds: [],  //举报材料盖章页ID
                reportType: 1, //举报类型 1-实名举报 2-匿名举报
                reportFileIds: [], //佐证材料
                informantPhone: '',//举报人手机号
                reportSubject: "1",
                questionType: '',
                unreliableType: '',
                unreliableActType: []
              }
              this.loading = false
              this.formdata.reportSubject = this.$route.query.id
              this.reportFileList = []
              this.certificateFileList = []
              this.businessLicenseFileList = []
              this.reportAttachmentFileList = []
            }).catch(res => {
              this.loading = false
              this.$message({
                message: res.response.data.message,
                type: 'warning'
              });
            })
          } else {
            this.$message({
              message: '请填写必填项',
              type: 'warning'
            });
          }
        })
      } else {
        this.$refs.formdata.validate((valid, errors) => {
          // 点击确定新增校验哪些值没传
          if (valid) {
            this.formdata.isSubmit = 1
            this.loading = true
            // 处理多选框
            let params = JSON.parse(JSON.stringify(this.formdata))
            params.unreliableActType = this.formdata.unreliableActType.join(',')
            personService.reportsub(params, this.otp).then((res) => {
              if (res.code != '200') {
                this.$message({
                  message: res.message,
                  type: 'warning'
                });
                this.loading = false
                return
              }
              this.$message({
                message: '提交成功 可到反馈结果页面查看',
                type: 'success'
              });
              this.formdata = {
                informantType: '1',
                informantDocumentType: "1",
                certificateAttachment: "", //举报人证件附件
                certificateAttachmentIds: [], //举报人证件附件ID
                businessLicenseIds: [], //营业执照附件ID
                reportAttachmentIds: [],  //举报材料盖章页ID
                reportType: 1, //举报类型 1-实名举报 2-匿名举报
                reportFileIds: [], //佐证材料
                informantPhone: '',//举报人手机号
                reportSubject: "1",
                questionType: '',
                unreliableType: '',
                unreliableActType: []
              }
              this.loading = false
              this.formdata.reportSubject = this.$route.query.id
              this.reportFileList = []
              this.certificateFileList = []
              this.businessLicenseFileList = []
              this.reportAttachmentFileList = []
              this.getOtp()
            }).catch(res => {
              this.loading = false
              this.$message({
                message: res.response.data.message,
                type: 'warning'
              });
              this.getOtp()
            })
          } else {
            this.$message({
              message: '请填写必填项',
              type: 'warning'
            });
          }
        })
      }
    },
    // 发送验证码
    queryphone () {
      let phone = ''
      if (this.formdata.informantType == '1') {
        phone = this.formdata.informantPhone
      } else if (this.formdata.informantType == '2') {
        phone = this.formdata.contactPhoneUnit
      }
      if (phone.length != 11 || phone == '') {
        this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
      } else {
        personService.queryphone(phone).then((res) => {
          let timer = 60
          console.log(timer);
          this.iscode = false;
          this.timeFun = setInterval(() => {
            --timer;
            this.timer = timer;
            if (timer == 0) {
              clearInterval(this.timeFun);
              this.iscode = true;
            }
          }, 1000);
        }).catch(err => {
          console.log(err);
          this.$message({
            message: err.response.data.message,
            type: "warning",
          });
        })
      }
    },
    // 有效证件附件上传文件成功回调
    effectivesuccess (response, file, fileList) {
      if (response.code !== '200') {
        this.$message({message: response.data, type: 'warning'});
        file.status = 'fail'
        return
      }
      this.getOtp()
      this.formdata.certificateAttachmentIds.push(response.data.id);
      // 手动触发验证
      this.$refs.formdata.validateField('certificateAttachmentIds')
    },
    // 有效证件附件上传删除回调
    beforeremove (response, file, fileList) {
      if(response && response.response && response.response.data && response.response.data.id) {
        let index = this.formdata.certificateAttachmentIds.indexOf(response.response.data.id);
        if(index > -1) {
          this.formdata.certificateAttachmentIds.splice(index, 1);
        }
      }
    },
    // 营业执照扫描件上传文件成功回调
    businessLicenseSuccess (response, file, fileList) {
      if (response.code !== '200') {
        this.$message({message: response.data, type: 'warning'});
        file.status = 'fail'
        return
      }
      this.getOtp()
      this.formdata.businessLicenseIds.push(response.data.id);
      // 手动触发验证
      this.$refs.formdata.validateField('businessLicenseIds')
    },
    // 营业执照扫描件上传删除回调
    businessLicenseRemove (response, file, fileList) {
      if(response && response.response && response.response.data && response.response.data.id) {
        let index = this.formdata.businessLicenseIds.indexOf(response.response.data.id);
        if(index > -1) {
          this.formdata.businessLicenseIds.splice(index, 1);
        }
      }
    },
    // 举报材料盖章页上传文件成功回调
    reportAttachmentSuccess (response, file, fileList) {
      if (response.code !== '200') {
        this.$message({message: response.data, type: 'warning'});
        file.status = 'fail'
        return
      }
      this.getOtp()
      this.formdata.reportAttachmentIds.push(response.data.id);
      // 手动触发验证
      this.$refs.formdata.validateField('reportAttachmentIds')
    },
    // 举报材料盖章页上传删除回调
    reportAttachmentRemove (response, file, fileList) {
      if(response && response.response && response.response.data && response.response.data.id) {
        let index = this.formdata.reportAttachmentIds.indexOf(response.response.data.id);
        if(index > -1) {
          this.formdata.reportAttachmentIds.splice(index, 1);
        }
      }
    },
    // 佐证材料上传文件成功回调
    evidencesuccess (response, file, fileList) {
      if (response.code !== '200') {
        this.$message({message: response.data, type: 'warning'});
        file.status = 'fail'
        return
      }
      this.getOtp()
      this.formdata.reportFileIds.push(response.data.id);
      console.log(this.formdata.reportFileIds, "佐证材料");
      // 手动触发验证
      this.$refs.formdata.validateField('reportFileIds')
    },
    // 佐证材料上传文件删除回调
    evidenbeforeremove (response, file, fileList) {
      if(response && response.response && response.response.data && response.response.data.id) {
        let index = this.formdata.reportFileIds.indexOf(response.response.data.id);
        if(index > -1) {
          this.formdata.reportFileIds.splice(index, 1);
        }
      }
      console.log(this.formdata.reportFileIds, "佐证材料");
    },
    beforeUploadFile(file) {
      const maxSize = 20 * 1024 * 1024; // 20MB，以字节为单位
      if (file.size > maxSize) {
        this.$message({message:"单个文件大小不能超过20MB，请重新上传。", type: 'warning'});
        return false; // 阻止上传
      }
      return true; // 允许上传
    },
    handleExcel () {
      // console.log("handleExcel");
    },
    getOtp () {
      personService.getOtp().then((res) => {
        if (res.code === '200') {
          this.otp = res.data
        } else {
          this.$message({message: res.data, type: 'warning'});
        }
      })
    }
  },
  mounted () {
    this.getOtp()
    this.getType('0',1)
    this.formdata.reportSubject = this.$route.query.id
  }
};
</script>

<style lang="scss" scoped>
.realname {
  //   padding-bottom: 50px;
  //   padding: 0 300px;
  margin: 0 auto;
  width: 1070px;
  display: flex;
  //   overflow: auto;
  //   height: 100%;
}

// .required:before{
// content:'* ';
// color: red;
// }

::v-deep .el-form-item {
  width: 50%;
}

::v-deep .el-form-item__label {
  width: 160px !important;
}

h3 {
  background-color: #1890ff;
  padding: 10px;
  text-align: center;
  margin: 0px 0 !important;
  color: #FFFFFF;
}

span {
  display: block;
  color: #000000;
  background-color: #FFFBE6;
  padding: 0 30px;
  line-height: 28px;
  border: 1px solid #FFE58F;
  font-size: 12px;
  margin: 20px 0;

  p {
    font-size: 16px;
  }
}

.jc-c .el-button {
  width: 100px;
}

.tips {
  display: flex;
  align-items: center;
  margin: 5px 0;
  justify-content: space-between;

  span {
    border: 0;
    display: flex;
    align-items: center;
    padding: 0;
    font-size: 18px;
    margin: 5px 0;
  }

  img {
    width: 20px;
    margin-right: 10px;
  }

  .back {
    width: 10px;
  }
}

::v-deep .el-form-item__content {
  display: flex;
}

::v-deep .el-select {
  width: 90%;

  .el-input {
    width: 100%;
  }
}

::v-deep .el-input, .el-input.is-disabled .el-input__inner {
  width: 90%;
}

::v-deep .upload {
  display: flex;
}

::v-deep .el-upload-list {
  display: flex;
  align-items: center;
}

::v-deep .el-upload-list__item:first-child {
  margin-top: 0;
}

.must {
  padding: 0;
  margin: 0;
  background-color: #1890ff;
  height: 0;
  display: inline-block;
  border: none;
  color: #F56C6C;
  font-size: 16px;
}

::v-deep .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266 !important;
  //color: #000 ;
  display: inline-block;
  height: 40px;
  line-height: 40px !important;
  //line-height: 32px !important;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>
